import styled, { css } from 'styled-components';
import {
  ICON_MARGIN,
  MARGIN_BETWEEN_ROWS,
  TIMELINE_LABEL_CONTAINER_PADDING_X,
  TIMELINES_ITEM_ROW_HEIGHT,
} from '../consts';
import { colors } from '@ardoq/design-tokens';
import { text2Bold } from '@ardoq/typography';
import { ChevronIcon } from '@ardoq/icons';

export const Label = styled.div<{ $shouldEllipsis?: boolean }>`
  flex: 1 0 32px;
  align-items: center;
  max-width: fit-content;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  margin-left: ${ICON_MARGIN}px;
  padding-right: ${TIMELINE_LABEL_CONTAINER_PADDING_X}px;
  ${({ $shouldEllipsis }) =>
    $shouldEllipsis &&
    css`
      text-overflow: ellipsis;
    `}
`;

export const GroupSubLabelWrapper = styled.span`
  display: flex;
  min-width: 0;
  max-width: fit-content;
  white-space: nowrap;
  ${text2Bold};
  color: ${colors.grey400};
`;

export const GroupSubLabelText = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  max-width: fit-content;
`;

export const LabelAndLinkContainer = styled.div`
  position: absolute;
  display: flex;
  margin-bottom: ${MARGIN_BETWEEN_ROWS}px;
  z-index: 4;
`;

export const LabelAndSubLabelContainer = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 100%;
`;

export const MainLabelContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  min-height: ${
    TIMELINES_ITEM_ROW_HEIGHT - TIMELINE_LABEL_CONTAINER_PADDING_X * 2
  }px;
`;

export const FieldDataExpander = styled(ChevronIcon)`
  color: ${colors.grey500};
`;

export const TimelineGroupExpander = styled(ChevronIcon)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: inherit;
  border: none;
  padding: 0;
`;
